if (!customElements.get('athena-variant-order')) {
  customElements.define(
    'athena-variant-order',
    class AthenaVariantOrder extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.inputs = Array.from(this.querySelectorAll('[data-athena-variant-quantity]'));
        this.total = this.querySelector('[data-athena-variant-total]');
        this.message = this.querySelector('[data-athena-variant-message]');
        this.submitButton = this.querySelector('[data-athena-variant-submit]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.resetSelections = this.resetSelections.bind(this);
      }

      connectedCallback() {
        this.resetSelections();
        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.inputs.forEach((input) => {
          input.addEventListener('input', () => this.updateSummary());
          input.addEventListener('change', () => this.updateSummary());
        });
        window.addEventListener('pageshow', this.resetSelections);
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.resetSelections);
      }

      resetSelections() {
        this.inputs.forEach((input) => {
          input.value = '0';
          input.setAttribute('value', '0');
        });
        this.hideMessage();
        this.updateSummary();
      }

      selectedItems() {
        return this.inputs
          .map((input) => ({
            id: Number(input.dataset.variantId),
            quantity: Math.max(0, Math.floor(Number(input.value) || 0)),
          }))
          .filter((item) => Number.isSafeInteger(item.id) && item.quantity > 0);
      }

      updateSummary() {
        const totalInMinorUnits = this.inputs.reduce((total, input) => {
          const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
          const price = Math.max(0, Number(input.dataset.variantPrice) || 0);
          return total + quantity * price;
        }, 0);

        if (this.total) this.total.textContent = this.formatMoney(totalInMinorUnits);
        if (this.submitButton) this.submitButton.disabled = this.selectedItems().length === 0;
      }

      formatMoney(amount) {
        const currency = this.dataset.currency || 'JPY';
        const locale = document.documentElement.lang || 'ja-JP';
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'symbol',
        }).format(amount / 100);
      }

      async onSubmit(event) {
        event.preventDefault();
        const items = this.selectedItems();
        if (!items.length || this.submitButton?.disabled) return;

        this.setLoading(true);
        this.hideMessage();

        try {
          const body = {items};
          if (this.cart) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
            this.cart.setActiveElement?.(document.activeElement);
          }

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'カートに追加できませんでした。');
          }

          if (this.cart && result.sections) {
            this.cart.classList.remove('is-empty');
            const firstAddedItem = result.items?.[0];
            if (!result.key && firstAddedItem?.key) result.key = firstAddedItem.key;
            this.cart.renderContents(result);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'athena-variant-order',
                productVariantId: firstAddedItem?.id || items[0]?.id,
                cartData: result,
              });
            }
          } else {
            window.location.assign(window.routes?.cart_url || '/cart');
            return;
          }

          this.resetSelections();
        } catch (error) {
          this.showMessage(error.message || 'カートに追加できませんでした。', true);
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(loading) {
        if (!this.submitButton) return;
        this.submitButton.classList.toggle('loading', loading);
        this.submitButton.setAttribute('aria-disabled', String(loading));
        this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        if (!loading) this.updateSummary();
      }

      showMessage(text, isError = false) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.hidden = false;
        this.message.classList.toggle('athena-variant-order-list__message--error', isError);
      }

      hideMessage() {
        if (!this.message) return;
        this.message.hidden = true;
        this.message.textContent = '';
        this.message.classList.remove('athena-variant-order-list__message--error');
      }
    }
  );
}
